export function createObject(keys: string[], values: any[]) {
  return keys.reduce((result, key, i) => ((result[key] = values[i]), result), {} as any);
}
